import SectionLabel from "@/components/SectionLabel";
import usePageMeta from "@/hooks/usePageMeta";

export default function Cookies() {
  usePageMeta({ title: "Cookies, LevelLeven", description: "Cookiegebruik op deze website." });
  return (
    <div>
      <section className="py-16 sm:py-24">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16">
          <SectionLabel>Cookies</SectionLabel>
          <h1 className="font-heading text-5xl sm:text-6xl leading-[1.05] tracking-tight text-[#1D2A22] font-light">
            Zo min mogelijk{" "}
            <span className="italic text-[#E06B3F]">cookies</span>.
          </h1>
        </div>
      </section>
      <section className="pb-24">
        <div className="max-w-[900px] mx-auto px-6 sm:px-10 lg:px-16 space-y-10 text-[#4A5D4E] leading-relaxed font-light text-lg">
          <p>
            Deze website plaatst <strong className="text-[#1D2A22] font-normal">geen tracking-cookies</strong> en
            gebruikt <strong className="text-[#1D2A22] font-normal">geen externe analytics</strong>. Er worden geen
            gegevens gedeeld met derden voor advertentie- of profileringsdoeleinden.
          </p>
          <div>
            <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">Functionele opslag</h2>
            <p>
              Uw browser kan tijdelijk gegevens onthouden die nodig zijn voor de werking van interactieve tools,
              bijvoorbeeld de ingevulde staat van de ROI-calculator of de zelfscan. Deze gegevens blijven lokaal
              in uw browser en worden niet door ons opgeslagen.
            </p>
          </div>
          <div>
            <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">Formulieren</h2>
            <p>
              Wanneer u een formulier verstuurt (contact, nieuwsbrief of ROI-scenario), worden de door u ingevulde
              gegevens verwerkt zoals beschreven in ons <a href="/privacy" className="text-[#E06B3F] link-underline">privacybeleid</a>.
            </p>
          </div>
          <div>
            <h2 className="font-heading text-2xl text-[#1D2A22] mb-3">Wijzigingen</h2>
            <p>
              Bij het toevoegen van analytics of andere cookies (bijvoorbeeld een cookievrije Plausible-implementatie)
              zullen wij vooraf om toestemming vragen en deze pagina bijwerken.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
